import React from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const GenerateToken = ({ title = "Generated Token", open, onClose, token }) => {

  /**
   * Copy modal text to clipboard
   */
  const copyToClipboard = () => {
    navigator.clipboard.writeText(token);
    toast.success("Coppied");
  }

  return (
    <Modal zIndex={2000} size={"xl"} centered isOpen={open} toggle={onClose}>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        <div style={{ wordBreak: "break-word" }}>
          {token}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={copyToClipboard}>
          Copy
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GenerateToken;

GenerateToken.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  token: PropTypes.string.isRequired,
  setGenerateModal: PropTypes.func
};
